import {FC} from 'react';
import {Box, Typography, useMediaQuery} from '@mui/material';
import Switch from '@/shared/components/Switches/Switch';
import {BODY2, PRIMARY, SUBTITLE2, TEXT} from '@/utils/constants';
import {ReactComponent as EditIcon} from '@icons/edit.svg';
import Button from '@/shared/components/Button';
import {INotificationSettingItem} from '@/utils/types';
import {notificationItemStyle} from './NotificationSettingItem.styles';

const NotificationSettingItem: FC<INotificationSettingItem> = ({
  title,
  description,
  isEnable,
  disable,
  onChange,
  isPhoneButton,
  onClick,
}) => {
  const isMobile = useMediaQuery('(max-width:767.98px)');

  return (
    <Box sx={notificationItemStyle.wrapperItem}>
      <Box>
        <Typography
          variant={SUBTITLE2}
          sx={{...notificationItemStyle.title, ...(disable && notificationItemStyle.disableTitle)}}
        >
          {title}
        </Typography>
        <Typography variant={BODY2} sx={notificationItemStyle.description}>
          {description}
        </Typography>
      </Box>
      {isPhoneButton && (
        <Button
          sx={notificationItemStyle.button}
          startIcon={<EditIcon />}
          title={isMobile ? '' : "Phone numbers"}
          variant={TEXT}
          color={PRIMARY}
          disableRipple
          onClick={onClick}
        />
      )}
      <Switch checked={isEnable} onChange={onChange} />
    </Box>
  );
};

export default NotificationSettingItem;
